import {
  getFormatedExpirationDate,
  getFormatedNumber,
} from 'cvlib/components/InputCard/utils/format';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import { PreferredPaymentIndicator } from 'containers/Payment/components/PreferredPaymentIndicator';
import './Cards.scss';

export default function Card({
  number,
  brand,
  type,
  action,
  expire,
  showPreferred = false,
  isPreferred = false,
}) {
  const translations = useSelector(state => state.translations);
  const assets = useSelector(state => state.asset);

  // const digits =
  //   getTranslationEmptyOrNullKey(
  //     'MDP_MetodosDePago_EditarMDPTarjetas_Texto_DigitosTarjeta',
  //     translations,
  //   ) || '**** **** **** ';

  const creditType = getTranslationEmptyOrNullKey(
    'MDP_MetodosDePago_EditarMDPTarjetas_Texto_Credito',
    translations,
  );

  const debitType = getTranslationEmptyOrNullKey(
    'MDP_MetodosDePago_EditarMDPTarjetas_Texto_Debito',
    translations,
  );

  const preferredText = getTranslationEmptyOrNullKey(
    'MDP_MetodosDePago_Tarjeta_Texto_Preferido',
    translations,
  );

  const getCardType = () => {
    if (!type) return '';

    if (type == 2) return creditType;
    return debitType;
  };

  const defaultCard =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Asset || '';
  const amexCard = assets?.MDP_MetodosDePago_Tarjeta_Asset_Amex || '';
  const masterCard = assets?.MDP_MetodosDePago_Tarjeta_Asset_MasterCard || '';
  const visaCard = assets?.MDP_MetodosDePago_Tarjeta_Asset_Visa || '';

  const defaultLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_AssetTipoTarjeta || '';
  const amexLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Logo_Amex || '';
  const masterLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Logo_MasterCard || '';
  const visaLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Logo_Visa || '';

  const getCardBackground = () => {
    switch (brand?.toLowerCase()) {
      case 'amex':
        return amexCard;
      case 'mastercard':
        return masterCard;
      case 'visa':
        return visaCard;
      default:
        return defaultCard;
    }
  };
  const getCardBrandLogo = () => {
    switch (brand?.toLowerCase()) {
      case 'amex':
        return amexLogo;
      case 'mastercard':
        return masterLogo;
      case 'visa':
        return visaLogo;
      default:
        return defaultLogo;
    }
  };

  const formatedNumber = useMemo(() => getFormatedNumber(number, ''), [number]);

  const formatedEDate = useMemo(() => getFormatedExpirationDate(expire), [
    expire,
  ]);

  return (
    <div
      className={`card ${action ? 'clickable' : ''}`}
      onClick={action}
      style={{
        backgroundImage: `url(${getCardBackground()})`,
      }}
    >

      {showPreferred && (
        <div className="card__preferred">
          <PreferredPaymentIndicator />
        </div>
      )}


      <div className="card__brand">
        {getCardBrandLogo() ? (
          <img className={'card__brand__logo'} src={getCardBrandLogo()} />
        ) : (
          <span className={'card__brand__logo'} />
        )}
      </div>

      <div className="card__number">
        {renderMaxLengthText(`${formatedNumber}`, 22)}
      </div>

      <div className="card__footer">
        <span className="card__expiry">{formatedEDate}</span>
        {/* <span className="card__type">
          {renderMaxLengthText(getCardType(), 7)}
        </span> */}
      </div>
    </div>
  );
}
